module.exports = __webpack_public_path__ + "static/img/img3.818e697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202111/img3.png
// module id = MPfk
// module chunks = 0